import applicationHistoryReducer from "./applicationHistoryReducer";

const applicationHistoryReducers = {
    applicationHistory: applicationHistoryReducer,
}

export default applicationHistoryReducers;